module.exports = __webpack_public_path__ + "img/shir_yes.187fb2f5.png";